export default function collapse() {
    document.querySelectorAll('.b-collapse')
        .forEach(collapse => {
            collapse.querySelectorAll('.b-collapse__item')
                .forEach(collapse__item => {
                    collapse__item.querySelector('.b-collapse__toggle').addEventListener('click', (e) => {
                        e.preventDefault();

                        if (!collapse__item.classList.contains('b-collapse__item--active')) {
                            collapse.querySelectorAll('.b-collapse__item').forEach(item => {
                                item.classList.remove('b-collapse__item--active');
                            });
                            collapse__item.classList.add('b-collapse__item--active')
                        } else {
                            collapse__item.classList.remove('b-collapse__item--active')
                        }
                    });
                });
        });

    document.querySelectorAll('.block-add-collapse')
        .forEach(collapse => {
            collapse.querySelectorAll('.block-add-collapse__item')
                .forEach(collapse__item => {
                    collapse__item.querySelector('.block-add-collapse__toggle').addEventListener('click', (e) => {
                        e.preventDefault();

                        if (!collapse__item.classList.contains('block-add-collapse__item--active')) {
                            collapse.querySelectorAll('.block-add-collapse__item').forEach(item => {
                                item.classList.remove('block-add-collapse__item--active');
                            });
                            collapse__item.classList.add('block-add-collapse__item--active')
                        } else {
                            collapse__item.classList.remove('block-add-collapse__item--active')
                        }
                    });
                });
        });
}
